// extracted by mini-css-extract-plugin
export var width100 = "H_ch g_ch";
export var design3Pos = "H_wK g_cM";